import { render, staticRenderFns } from "./ActiveSubstances.vue?vue&type=template&id=c026c058&"
import script from "./ActiveSubstances.vue?vue&type=script&lang=js&"
export * from "./ActiveSubstances.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports